import React, { Component } from 'react';
import _ from "lodash";
import "./clientes.css";

class Clientes extends Component {
    renderClients(clients){
        return _.map(clients, client => {
            return (
                <div key={client.id} className="clientes-content-item">
                    <img src={client.logo.src} alt={client.logo.alt}/>
                </div>
            )
        });
          
        
    }

    render() {
        return (
            <div className="clientes">
                <div className={`section-title montserrat fw-bold ${this.props.visible ? "animated fadeInUp" : "opa-0"}`}>
                    <h2>Nuestros Clientes</h2>
                    <div className="section-title-line"/>
                </div>
                <div className="clientes-content">
                    {this.renderClients(this.props.content.clients)}
                </div>
            </div>
        );
    }
}

export default Clientes;


// WEBPACK FOOTER //
// ./src/sections/Clientes.js